import { clearStorage } from "../utils/helpers/auth";
import { UserType } from "../utils/types";

export interface UserAuthType {
  id: number;
  uuid: string;
  email: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  phoneNumber: string;
  userType: UserType;
  createdAt: string;
  updatedAt: string;
}

export const useAuth = () => {
  const logout = async () => {
    clearStorage();
    window.location.href = "/login";
  };

  return {
    logout,
  };
};
